import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReOrderPopup from "../../../components/Popup/ReOrderPopup";
import DirectParcelReturnPopup from "../../../components/Popup/DirectParcelReturnPopup";
import ReviewPopup from "../../../components/Popup/ReviewPopup";
import { formatLocalString } from "../../../utils/validation";
import { MY_PAGE_ORDER_CANCEL_URL, MY_PAGE_REORDER_URL, MY_PAGE_ORDER_CONFIRM_URL, MY_PAGE_ORDER_EXCHANGE_RETURN_CANCEL_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import PopupLoginError from "../../../components/Popup/LoginError";
import DeliveryStatusPopup from "../../../components/Popup/DeliveryStatusPopup";
import { useLanguage } from "../../../hooks/useLanguage";

function MyOrderItem({type, orderList, orderType, orderData, point}){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [requestReorder, setRequestReorder] = useState(false);
  const [writeReview, setWriteReview] = useState(false);
  const [parcelReturn, setParcelReturn] = useState(false);
  const [isPopupLoginError, setIsPopupLoginError] = useState("")
  const [orderSeq, setOrderSeq] = useState(null);
  const [selectedReportFlag, setSelectedReportFlag] = useState(null);

  const [isStatusPopup, setStatusPopup ] = useState(false); // 배송조회 팝업
  const handleStatusPopup = () => {
    setStatusPopup(true)
  };


  // 재주문 팝업
  const handleRequestReorder = (orderSeq) => {
    // API 호출
    instance.post(MY_PAGE_REORDER_URL, {
      order_kind: type,
      order_seq: orderSeq
    })
    .then((response) => {
      if (response.data.code === 200) {
        // API 호출 성공 시 팝업 열기
        setRequestReorder(true);
      } else {
        setIsPopupLoginError({
          message: '재주문 요청에 실패했습니다.',
          action: 'refresh'
        });
      }
    })
    .catch((error) => {
      console.error('재주문 요청 오류:', error);
      setIsPopupLoginError({
        message: '재주문 요청 중 오류가 발생했습니다.',
        action: 'refresh'
      });
    });
  };

  // 연장 버튼 클릭 핸들러
  const handleExtension = (orderNumber) => {
    // orderList 배열에서 해당 주문번호와 일치하는 주문 객체 찾기
    const currentOrder = orderList.find(order => order.order_seq === orderNumber);

    // 찾은 주문 객체에서 필요한 정보 추출
    const state = {
      orderNumber,
      rental_store_name: currentOrder?.return_store_name,
      rental_sdate: currentOrder?.rental_edate

    };

    navigate(`/myPage/orderExtension/${type}?orderNumber=${orderNumber}`, { state });
  };

  // 상세페이지
  const handleOrderDetail = (orderNumber, isCancel = false) => {
    const query = isCancel
      ? `/myPage/order?type=${type}&orderNumber=${orderNumber}&order_status=Cancel`
      : `/myPage/order?type=${type}&orderNumber=${orderNumber}`;
    navigate(query);
  };

  const handleReturnForm = (orderSeq, itemSeq) => {
    navigate('/myPage/orderReturnForm', {
      state: {
        orderSeq,
        itemSeq
      }
    });
  };

  const handleExchangeForm = (orderSeq, itemSeq) => {
    navigate('/myPage/orderExchangeForm', {
      state: {
        orderSeq,
        itemSeq
      }
    });
  };

  const handleWriteReview = (orderSeq, reportFlag) => {
    setWriteReview(true);
    setOrderSeq(orderSeq);
    setSelectedReportFlag(reportFlag);
  };

  const handleParcelReturn = (orderSeq) => {
    setParcelReturn(true);
    setOrderSeq(orderSeq);
  };

  const handleOrderCancel = (orderSeq) => {
    instance.post(MY_PAGE_ORDER_CANCEL_URL, {
      order_seq: orderSeq,
    })
    .then((response) => {
      if (response.data.code === 200) {
        setIsPopupLoginError({
          message: '주문을 취소처리 합니다.',
          action: 'navigate_login'
        });
      } else {
        // 코드가 200이 아닌 경우 (코드가 -200인 경우 포함)
        setIsPopupLoginError({
          message: response.data.message || '주문취소에 실패했습니다.',
          action: 'navigate_login'
        });
      }
    })
    .catch((error) => {
      console.log(error);
      setIsPopupLoginError({
        message: '주문취소에 실패했습니다.',
        action: 'navigate_login'
      });
    });
  };

  const handleConfirm = () => {
    if (isPopupLoginError.action === 'navigate_login') {
      window.location.reload();
    } else if (isPopupLoginError.action === 'refresh') {
      navigate('/');
    } else if (isPopupLoginError.action === 'confirm_return_cancel') {
      // 확인 버튼을 누르면 실제 API 호출
      executeReturnCancel(isPopupLoginError.return_code);
      setIsPopupLoginError(false);
      return; // 여기서 return하여 아래 setIsPopupLoginError(false) 실행 방지
    }
    setIsPopupLoginError(false); // 팝업 닫기
  };

  // 구매확정 처리
  const handleConfirmPurchase = (orderSeq, itemOptionSeq) => {
    instance.post(MY_PAGE_ORDER_CONFIRM_URL, {
      order_seq: orderSeq,
      item_option_seq: itemOptionSeq
    })
    .then((response) => {
      if (response.data.code === 200) {
        setIsPopupLoginError({
          message: '구매가 확정되었습니다.',
          action: 'navigate_login'
        });
      } else {
        setIsPopupLoginError({
          message: response.data.message || '구매확정에 실패했습니다.',
          action: 'navigate_login'
        });
      }
    })
    .catch((error) => {
      console.log(error);
      setIsPopupLoginError({
        message: '구매확정에 실패했습니다.',
        action: 'navigate_login'
      });
    });
  };

  // cartListData가 정의되어 있는지 확인
  if (!orderList || !Array.isArray(orderList)) {
    return <div className="no_result">
      <p>주문 상품이 없습니다.</p>
    </div>
  }

  // 교환 / 반품 철회 api
  const handleReturnCancel = (return_code, complete_flag) => {
    // complete_flag가 'Y'인 경우 확인 팝업 표시
    if (complete_flag === 'Y') {
      setIsPopupLoginError({
        message: '해당 상품은 동일 옵션 내 다른 상품이 이미 구매확정 처리된 상태입니다. 교환(반품) 신청을 철회하실 경우, 해당 상품도 함께 구매확정 처리되어 이후 교환 및 반품이 불가능합니다. 철회를 진행하시겠습니까?',
        action: 'confirm_return_cancel',
        return_code: return_code
      });
    } else {
      // complete_flag가 'Y'가 아닌 경우 바로 API 호출
      executeReturnCancel(return_code);
    }
  };

  // 실제 API 호출 함수
  const executeReturnCancel = (return_code) => {
    instance.post(MY_PAGE_ORDER_EXCHANGE_RETURN_CANCEL_URL, {
      return_code: return_code
    })
    .then((response) => {
      if (response.data.code === 200) {
        setIsPopupLoginError({
          message: '교환/반품 철회가 완료되었습니다.',
          action: 'navigate_login'
        });
      } else {
        setIsPopupLoginError({
          message: response.data.message || '교환/반품 철회에 실패했습니다.',
          action: 'navigate_login'
        });
      }
    })
    .catch((error) => {
      console.log(error);
      setIsPopupLoginError({
        message: '교환/반품 철회에 실패했습니다.',
        action: 'navigate_login'
      });
    });
  };

  // 상태명 → 클래스명 매핑
  const STATUS_CLASS = {
    '주문접수': 'badge_order',
    '장비세팅': 'badge_setting',
    '계약대기중': 'badge_contract_wait',
    '대여중': 'badge_rent',
    '대여완료중': 'badge_rent_done',
    '반납지연': 'badge_return_delay',
    '주문연장': 'badge_extend',
    '반납완료': 'badge_return_done',
    '주문취소': 'badge_cancel',
    '확인중': 'badge_check',
    '확인완료': 'badge_check_done',
    '입금전': 'badge_before_pay',
    '배송준비중': 'badge_delivery_ready',
    '배송대기중': 'badge_delivery_wait',
    '배송중': 'badge_delivering',
    '배송완료': 'badge_delivery_done',
    '반품': 'badge_return',
    '교환': 'badge_exchange',
  };

  return(
    <div className="order_page">

      {/* 판매상품 외 UI */}
      {(type !== 'sale') && (
        orderList.map((order, index) => (
          <div className="manage_list" key={index}>
            {/* 현재 진행상태에따라 뱃지, 버튼 바뀜 */}
            <div className="manage_con">
              <div className="info_item flex-btw">
                <div className="flex-center">
                  <span>{t('order_date')}: {order?.regist_date?.split(' ')[0]}</span>
                  <button
                    type="button"
                    className="text_underline group_item"
                    onClick={() => handleOrderDetail( order?.order_seq )}
                  >
                    {order?.order_seq}
                    <i className="arrow_btn deep"></i>
                  </button>
                </div>
              </div>

              <div className="info_detail">
                <div>
                  {/* <div className="badge sm g-100">{order?.order_step_name}</div>  */}
                  <div className={`badge_color ${STATUS_CLASS[order?.order_step_name] || ''}`}>
                    {order?.order_step_name}
                  </div>

                  <div className="summary">
                    {type === 'visit' || type === 'estimate' ? (
                      <>
                        <p>{t('rental_info')}: <span>{order?.rental_store_name} {order?.rental_sdate}</span></p>
                        <p>{t('return_info')}: <span>{order?.return_store_name} {order?.rental_edate}</span></p>
                      </>
                    ) : (
                      <>
                        <p>{t('rental_info')}: <span>{order?.rental_sdate.split(' ')[0]}</span></p>
                        <p>{t('return_info')}: <span>{order?.rental_edate.split(' ')[0]}</span></p>
                      </>
                    )}
                    <p>{t('total_rental_days', {count: order?.rental_period})}</p>
                    <p>{t('payment_amount')}:&#160;
                      <span className="strong_b3">₩</span>
                      <span className="strong_b1">{formatLocalString(order?.settleprice || 0)}</span>
                    </p>
                    {type === 'visit' && (
                      <p>
                          {t("deposit")}:&#160;
                        <span>₩</span>
                      <span>{formatLocalString(order?.deposit_price || 0)}</span>
                    </p>
                    )}
                    {/* type가 visit일때만 보이고, order?.refund_deposit_price가 null일 때 보이지 않게  */}
                    {type === 'visit' && order?.refund_deposit_price !== null && (
                      <p>
                          {t("deposit_refund_amount")}:&#160;
                        <span style={{color: '#FA4718'}}>₩</span>
                      <span style={{color: '#FA4718'}}>{formatLocalString(order?.refund_deposit_price || 0)}</span>
                    </p>
                    )}
                    <div className="flex-center">
                      <p>{t('rating')}:</p>&#160;
                      {/* 평점을 별 개수로 표시 */}
                      {order?.grade_star > 0 ? (
                        // 평점이 있는 경우 해당 수만큼 별 아이콘 표시
                        Array.from({ length: order.grade_star }, (_, index) => (
                          <i key={index} className="star_icon"></i>
                        ))
                      ) : (
                        // 평점이 0이거나 없는 경우
                        <>
                          <i className="star_icon"></i>
                          <span> - </span>
                        </>
                      )}
                    </div>

                    {/* [매장, 택배주문] '반납완료' 상태 사용자에게만 매장 및 직원들에 '이용평가' 표출 */}
                    {(type === 'visit' || type === 'parcel') && (
                      <>
                        {order?.order_step_name === '반납완료' && (
                          <div>
                            <p>{t('evaluation')}:&#160;
                              {order?.rating_flag === 'Y' ? (
                                // 이미 평가한 경우
                                <span style={{ color: 'black' }}>{t('evaluation_completed')}</span>
                                // 평가 기간이 만료된 경우 flag값이 E로 내려옴
                              ) : order?.rating_flag === 'E' ? (
                                <span style={{ color: '#BBB' }}>평가 기간 만료</span>
                              ) : (
                                // 아직 평가하지 않은 경우
                                <button
                                  type="button"
                                  className="blue_txt_btn"
                                  onClick={() => handleWriteReview(order?.order_seq, order?.report_flag)}
                                >
                                  <p className="blue text_underline">{t('evaluation_info7')}</p>
                                </button>
                              )}
                            </p>
                          </div>
                        )}
                      </>
                    )}

                    {/* [택배주문]  '배송완료, 대여중, 반납지연' 상태일 떄 '직접 발송하기' 표출 */}
                    { type === 'parcel' && (
                      <>
                        {(order?.order_step_name === '배송완료' || order?.order_step_name === '대여중' || order?.order_step_name === '반납지연') && order?.pickup_method === 'customer' && order?.return_complete_flag === "N" ? (
                          <div>
                            <p>{t('delivery_return')}:&#160;
                              <button
                                type="button"
                                className="blue_txt_btn"
                                onClick={() => handleParcelReturn(order?.order_seq)}
                              >
                                <p className="blue text_underline">{t('direct_return')}</p>
                              </button>
                            </p>
                          </div>
                        ) : null}
                      </>
                    )}

                  </div>
                </div>

                <div className="btn_group_4 column">
                  {/* 매장방문주문 관리 */}
                  {type === 'visit' && (
                    <>
                      {order?.order_step_name === '주문접수' && (
                        <button
                          type="button"
                          className="gray default_btn xs"
                          onClick={() => handleOrderCancel(order?.order_seq)}
                        >
                          {t('order_cancel')}
                        </button>
                      )}

                      {order?.order_step_name === '대여중' && (
                        <button
                          type="button"
                          className="black default_btn xs"
                          onClick={() => handleExtension(order?.order_seq)}
                        >
                          {t('extension')}
                        </button>
                      )}

                      {order?.order_step_name === '반납완료' && (
                        <button
                          type="button"
                          className="black default_btn xs"
                          onClick={() => handleRequestReorder(order?.order_seq)}
                        >
                          {t('reorder')}
                        </button>
                      )}

                      {order?.order_step_name === '반납지연' && (
                        <button
                          type="button"
                          className="gray default_btn xs"
                          onClick={() => handleExtension(order?.order_seq)}
                        >
                          {t('extension')}
                        </button>
                      )}

                      {order?.order_step_name === '주문취소' && (
                        <button
                          type="button"
                          className="white default_btn xs"
                          onClick={() => handleOrderDetail( order?.order_seq, true )}
                        >
                          {t('cancel_info2')}
                        </button>
                      )}

                    </>
                  )}

                  {/* 택배수령주문 관리 */}
                  {type === 'parcel' && (
                    <>
                      {order?.order_step_name === '배송대기중' && (
                        <button
                          type="button"
                          className="gray default_btn xs"
                          onClick={() => handleOrderCancel(order?.order_seq)}
                        >
                          {t('order_cancel')}
                        </button>
                      )}

                      {order?.order_step_name === '배송중' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                        >
                          {t('delivery_search')}
                        </button>

                        <button
                          type="button"
                          className="black default_btn xs"
                          onClick={() => handleExtension(order?.order_seq)}
                        >
                          {t('extension')}
                        </button>
                        </>
                        )}

                      {order?.order_step_name === '배송완료' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                        >
                          {t('delivery_search')}
                        </button>

                        <button
                          type="button"
                          className="black default_btn xs"
                          onClick={() => handleExtension(order?.order_seq)}
                        >
                          {t('extension')}
                        </button>
                      </>
                      )}

                      {order?.order_step_name === '대여중' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                          >
                            {t('delivery_search')}
                          </button>

                          <button
                            type="button"
                            className="black default_btn xs"
                            onClick={() => handleExtension(order?.order_seq)}
                          >
                          {t('extension')}
                          </button>
                        </>
                      )}

                      {order?.order_step_name === '반납지연' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                          >
                            {t('delivery_search')}
                          </button>

                          <button
                            type="button"
                            className="black default_btn xs"
                            onClick={() => handleExtension(order?.order_seq)}
                          >
                          {t('extension')}
                          </button>
                        </>
                      )}

                      {order?.order_step_name === '주문연장' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                          >
                            {t('delivery_search')}
                          </button>

                        </>
                      )}

                      {order?.order_step_name === '반납완료' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={handleStatusPopup}
                          >
                            {t('delivery_search')}
                          </button>

                          <button
                            type="button"
                            className="black default_btn xs"
                            onClick={() => handleRequestReorder(order?.order_seq)}
                          >
                            {t('reorder')}
                          </button>
                        </>
                      )}

                      {order?.order_step_name === '주문취소' && (
                        <>
                          <button
                            type="button"
                            className="white default_btn xs"
                            onClick={() => handleOrderDetail( order?.order_seq, true )}
                          >
                            {t('cancel_info2')}
                          </button>
                        </>
                      )}

                    </>
                  )}

                {/* 견적서 관리 */}
                {type === 'estimate' && (
                  <>
                    {['주문접수', '확인중', '확인완료'].includes(order?.step_name) && (
                      <button
                        type="button"
                        className="gray default_btn xs"
                        onClick={() => handleOrderCancel(order?.order_seq)}
                      >
                        {t('order_cancel')}
                      </button>
                    )}
                  </>
                )}

                  {/* 판매상품 관리 */}
                  {type === 'sale' && (
                    <>
                      <button
                        type="button"
                        className="black default_btn xs"
                        onClick={() => handleRequestReorder(order?.order_seq)}
                      >
                        {t('reorder')}
                      </button>
                      <button
                        type="button"
                        className="gray default_btn xs"
                        onClick={() => handleOrderCancel(order?.order_seq)}
                      >
                        {t('order_cancel')}
                      </button>
                      <button
                        type="button"
                        className="black default_btn xs"
                        onClick={() => handleExtension(order?.order_seq)}
                      >
                        {t('extension')}
                      </button>
                      <button
                        type="button"
                        className="white default_btn xs"
                        onClick={handleStatusPopup}
                      >
                        {t('delivery_search')}
                      </button>
                      <button
                        type="button"
                        className="white default_btn xs"
                        onClick={() => handleOrderDetail( order?.order_seq, true )}
                      >
                        {t('cancel_info2')}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      )}


      {/* 판매상품 UI */}
      {(type === 'sale') && (
        <>
          {orderType === 'exchange' && (
            // exchange 타입일 때 UI
            <div className="order_item default_prod manage_list">
              <div className="manage_con sale_con">
                <div className="info_item flex-btw">
                  <div className="flex-center">
                    <span>{t('order_date')}: {orderList[0]?.regist_date?.split(' ')[0]}</span>
                    <button
                      type="button"
                      className="text_underline group_item"
                      style={{textDecoration: 'none'}}
                    >
                      {orderList[0]?.order_seq}
                    </button>
                  </div>
                </div>

                <div className="prod_info">
                  <div className="column flex-12 sale_box">
                    <div>
                      <div className="badge sm g-100">{t('delivery_completed')}</div>
                    </div>
                    <div className="prod_container">
                      <img
                        src={orderList[0]?.goods_image}
                        alt="상품 이미지"
                        className="order_prod_img"
                        loading="lazy"
                      />
                      <div className="prod_title">
                        <p className="title ellipsis1">{orderList[0]?.goods_name}</p>
                        <p className="sub_title ellipsis1">{orderList[0]?.description_kr_01}</p>
                        {orderList[0]?.option1 && orderList[0]?.option2 ? (
                          <p className="option_count">{t('option')}: {orderList[0]?.option1}, {orderList[0]?.option2} / {t('quantity_txt')}<span className="quo_count"> :{orderList[0]?.ea}{t('quantity_count_txt')}</span></p>
                        ) : null}
                        <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1">{orderList[0]?.price ? formatLocalString(orderList[0]?.price) : '0'}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {orderData && orderType !== 'exchange' ? (
            // orderData가 있는 경우 (단일 주문)
            <div className="order_item default_prod manage_list">
              <div className="manage_con sale_con">
                <div className="info_item flex-btw">
                  <div className="flex-center">
                    <span>{t('order_date')}: {orderData?.regist_date.split(' ')[0]}</span>

                    <button
                      type="button"
                      className="text_underline group_item"
                      onClick={() => handleOrderDetail(orderData?.order_seq)}
                      style={{textDecoration: orderType === 'sale_detail' ? 'none' : 'underline'}}
                    >
                      {orderData?.order_seq}
                      {orderType !== 'sale_detail' && (
                        <i className="arrow_btn deep"></i>
                      )}
                    </button>
                  </div>

                  {/* 주문상태에 따라 아래 버튼 둘 중 하나만 노출 */}
                  {(orderData?.step_name === '주문접수' || orderData?.step_name === '입금전' || orderData?.step_name === '배송대기중') && (
                  <button
                    className="gray default_btn xs"
                    type="button"
                    onClick={() => handleOrderCancel(orderData?.order_seq)}
                  >
                    {t('order_cancel')}
                  </button>
                  )}
                </div>

                {orderList?.map((product, index) => (
                <div className="prod_info" key={index}>
                  <div className="column flex-12 sale_box">
                    <div>
                      <div className="badge sm g-100">{product?.step_name}</div>
                    </div>
                    <div className="prod_container">
                      <img
                        src={product?.goods_image}
                        alt="상품 이미지"
                        className="order_prod_img"
                        loading="lazy"
                      />
                      <div className="prod_title">
                        <p className="title ellipsis1">{product?.goods_name}</p>
                        <p className="sub_title ellipsis1">{product?.description_kr_01}</p>
                        <p className="option_count">
                          {(() => {
                            const options = [
                              product?.option1,
                              product?.option2,
                              product?.option3,
                              product?.option4,
                              product?.option5
                            ].filter(Boolean);

                            return (
                              <>
                              {options.length > 0 && (
                                <>
                                  {t('option')}: {options.join(', ')}
                                  /
                                </>
                              )}
                              {t('quantity_txt')}<span className="quo_count"> :{product?.ea}{t('quantity_count_txt')}</span>
                            </>
                            );
                          })()}
                        </p>
                        <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1">{product?.price ? formatLocalString(product?.price) : '0'}</span></p>
                      </div>
                    </div>
                  </div>
                  <div className="info_box column ">
                    {(product?.step_name === '배송중' || product?.step_name === '배송완료' || product?.step_name === '교환완료' || product?.step_name === '반품처리중' || product?.step_name === '구매확정' || product?.step_name === '교환처리중' || product?.step_name === '반품완료') && (
                    <div className="price">
                      <p>{product?.delivery_company_name}</p>
                      <p className="blue text_underline">{product?.delivery_number}</p>
                    </div>
                    )}
                    <div className="btn_group_4">
                      {product?.step_name === '배송완료' && (
                      <button
                        type="button"
                        className="white default_btn xs"
                        onClick={() => handleExchangeForm(orderData?.order_seq, product?.item_seq)}
                      >
                        {t('exchange_application')}
                      </button>
                      )}
                      {product?.step_name === '배송완료' && (
                      <button
                        type="button"
                        className="white default_btn xs"
                        onClick={() => handleReturnForm(orderData?.order_seq, product?.item_seq)}
                      >
                        {t('return_application')}
                      </button>
                      )}
                    </div>
                    {product?.step_name === '반품신청' && (
                    <button className="white default_btn xs" type="button" onClick={() => handleReturnCancel(product?.return_code, orderData?.complete_flag)}>
                      {t('return_cancel')}
                    </button>
                    )}
                    {product?.step_name === '교환신청' && (
                      <button className="white default_btn xs" type="button" onClick={() => handleReturnCancel(product?.return_code, orderData?.complete_flag)}>
                        {t('exchange_cancel')}
                      </button>
                    )}
                  </div>
                  <div className="btn_group_4 column">
                    {(product?.step_name === '배송중' || product?.step_name === '배송완료') && (
                    <button
                      className="black default_btn xs"
                      type="button"
                      onClick={() => handleConfirmPurchase(orderData?.order_seq, product?.item_option_seq)}
                    >
                      {t('purchase_confirmation')}
                    </button>
                    )}
                  </div>
                </div>
                ))}
              </div>
            </div>
          ) : (
            // orderList가 있는 경우 (리스트 형태)
            orderType !== 'exchange' && orderList.map((order, index) => (
              <div className="order_item default_prod manage_list" key={index}>
                <div className="manage_con sale_con">
                  <div className="info_item flex-btw">
                    <div className="flex-center">
                      <span>{t('order_date')}: {order?.regist_date}</span>

                      <button
                        type="button"
                        className="text_underline group_item"
                        onClick={() => handleOrderDetail( order?.order_seq )}
                        style={{textDecoration: orderType === 'sale_detail' ? 'none' : 'underline'}}
                      >
                        {order?.order_seq}
                        {orderType !== 'sale_detail' && (
                          <i className="arrow_btn deep"></i>
                        )}
                      </button>
                    </div>

                    {/* 주문상태에 따라 아래 버튼 둘 중 하나만 노출 */}
                    {(order?.order_step_name === '주문접수' || order?.order_step_name === '입금전') && (
                    <button
                      className="gray default_btn xs"
                      type="button"
                      onClick={() => handleOrderCancel(order?.order_seq)}
                    >
                      {t('order_cancel')}
                    </button>
                    )}
                    {order?.order_step_name === '주문취소' && (
                    <button
                      type="button"
                      className="white default_btn xs"
                      onClick={() => handleOrderDetail( order?.order_seq, true )}
                    >
                      {t('cancel_info2')}
                    </button>
                    )}
                  </div>

                  {order?.sale_product_info?.map((product, index) => (
                  <div className="prod_info" key={index}>
                    <div className="column flex-12 sale_box">
                      <div>
                        <div className="badge sm g-100">{product?.step_name}</div>
                      </div>
                      <div className="prod_container">
                        <img
                          src={product?.image}
                          alt="상품 이미지"
                          className="order_prod_img"
                          loading="lazy"
                        />
                        <div className="prod_title">
                          <p className="title ellipsis1">{product?.goods_name}</p>
                          <p className="sub_title ellipsis1">{product?.description_kr_01}</p>
                          <p className="option_count">
                            {(() => {
                              const options = [
                                product?.option1,
                                product?.option2,
                                product?.option3,
                                product?.option4,
                                product?.option5
                              ].filter(Boolean);

                              return (
                                <>
                                  {t('option')}: {options.length > 0 ? options.join(', ') : ''}
                                  / {t('quantity_txt')}<span className="quo_count"> :{product?.ea}{t('quantity_count_txt')}</span>
                                </>
                              );
                            })()}
                          </p>
                          <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1">{product?.price ? formatLocalString(product?.price) : '0'}</span></p>
                        </div>
                      </div>
                    </div>
                    <div className="info_box column ">
                      {(product?.step_name === '배송중' || product?.step_name === '배송완료' || product?.step_name === '교환완료' || product?.step_name === '반품처리중' || product?.step_name === '구매확정' || product?.step_name === '교환처리중' || product?.step_name === '반품완료') && (
                      <div className="price">
                        <p>{order?.delivery_company_name}</p>
                        <p className="blue text_underline">{order?.delivery_number}</p>
                      </div>
                      )}
                      <div className="btn_group_4">
                        {product?.step_name === '배송완료' && (
                        <button
                          type="button"
                          className="white default_btn xs"
                          onClick={() => handleExchangeForm(order?.order_seq, product?.item_seq)}
                        >
                          {t('exchange_application')}
                        </button>
                        )}
                        {product?.step_name === '배송완료' && (
                        <button
                          type="button"
                          className="white default_btn xs"
                          onClick={() => handleReturnForm(order?.order_seq, product?.item_seq)}
                        >
                          {t('return_application')}
                        </button>
                        )}
                      </div>
                      {product?.step_name === '반품신청' && (
                      <button
                        className="white default_btn xs"
                        type="button"
                        onClick={() => handleReturnCancel(product?.return_code, product?.complete_flag)}
                      >
                        {t('return_cancel')}
                      </button>
                      )}
                      {product?.step_name === '교환신청' && (
                        <button
                          className="white default_btn xs"
                          type="button"
                          onClick={() => handleReturnCancel(product?.return_code, product?.complete_flag)}
                        >
                          {t('exchange_cancel')}
                        </button>
                        )}
                    </div>
                    <div className="btn_group_4 column">
                      {(product?.step_name === '배송중' || product?.step_name === '배송완료') && (
                      <button
                        className="black default_btn xs"
                        type="button"
                        onClick={() => handleConfirmPurchase(order?.order_seq, product?.item_option_seq)}
                      >
                        {t('purchase_confirmation')}
                      </button>
                      )}
                    </div>
                  </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </>
      )}

      {/* 재주문 팝업 */}
      <ReOrderPopup
        isPopup={requestReorder}
        setIsPopup={setRequestReorder}
        orderType={type === 'visit' ? 'visit' : 'parcel'}
      />

      {/* 이용평가 팝업 */}
      <ReviewPopup
        isPopup={writeReview}
        setIsPopup={setWriteReview}
        type={type}
        order_seq={orderSeq}
        report_flag={selectedReportFlag}
        point={point}
      />

      {/* 택배 반납 > 직접 발송하기 팝업 */}
      <DirectParcelReturnPopup
        isPopup={parcelReturn}
        setIsPopup={setParcelReturn}
        order_seq={orderSeq}
      />

      <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError} onConfirm={handleConfirm}/>

      {/* 배송조회 팝업 */}
      <DeliveryStatusPopup
        isPopup={isStatusPopup}
        setIsPopup={setStatusPopup}
      />
    </div>
  )
};

export default MyOrderItem;
